/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHubtranTrx.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/hubtran-trx";

export class AutogenModelHubtranTrx<RowType extends ModelRow> extends Endpoint<RowType, RowHubtranTrxFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHubtranTrx extends ModelRow<RowHubtranTrxFields> {
	constructor(values?: Partial<RowHubtranTrxFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHubtranTrxFields {
	company_id: string;
	entered_date: Date;
	fingerprint: string;
	hubtran_id: string;
	hubtran_trans_type: string;
	id: string;
	movement_id: string;
	parent_row_id: string;
	row_field: string;
	row_id: string;
	row_table: string;
	transaction_mode: string;
	transfer_date: Date;
	transfer_exception: string;
	transfer_failed: string;
	version: number;
}

